import React from 'react';
import styled from 'styled-components';

interface ProgressBarProps {
  currentPage: number;
  totalPages: number;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0 40px 0;
  padding: 20px; 
  border-radius: 12px;
`;

const Bar = styled.ul`
  max-width: 600px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: #e9ecef;
    z-index: 1;
    transform: translateY(-50%);
  }
  
  li {
    width: 40px;
    height: 40px;
    list-style: none;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
    font-weight: 600;
    
    &.completed {
      background: #28a745;
      border: none;
      color: #fff;
      box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
    }
    
    &.active {
      background:rgba(235, 206, 80, 0.99);
      border: none;
      color:rgb(182, 135, 79);
      box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
    }
    
    &.pending {
      background: #fff;
      border: 2px solid #e9ecef;
      color: #adb5bd;
    }
  }
`;

const StepNumber = styled.span<{ isCompleted: boolean; isActive: boolean }>`
  font-size: ${props => props.isActive ? '16px' : '14px'};
  font-weight: 600;
  color: ${props => {
    if (props.isCompleted) return '#fff';
    if (props.isActive) return 'rgb(182, 135, 79)';
    return '#adb5bd';
  }};
`;

const Checkmark = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #fff;
`;

const ProgressBar: React.FC<ProgressBarProps> = ({ currentPage, totalPages }) => {
  return (
    <Container>
      <Bar>
        {Array.from({ length: totalPages }, (_, index) => {
          const pageNumber = index + 1;
          const isCompleted = currentPage > pageNumber;
          const isActive = currentPage === pageNumber;
          const isPending = currentPage < pageNumber;
          
          let className = 'pending';
          if (isCompleted) {
            className = 'completed';
          } else if (isActive) {
            className = 'active';
          }
          
          return (
            <li
              key={pageNumber}
              className={className}
            >
              {isCompleted ? (
                <Checkmark>✓</Checkmark>
              ) : (
                <StepNumber isCompleted={isCompleted} isActive={isActive}>
                  {pageNumber}
                </StepNumber>
              )}
            </li>
          );
        })}
      </Bar>
    </Container>
  );
};

export default ProgressBar;